<template>
    <!--Start Page Banner-->
    <div class="page-banner-area bg-1">
            <div class="container">
                <div class="page-banner-content">
                    <h1>Scout and Guide</h1>
                    <ul>
                        <li><a href="/">Home</a></li>
                        <li>Student Corner</li>
                        <li>Cells</li>
                        <li>Scout and Guide</li>
                    </ul>
                </div>
            </div>
        </div>
        <!--End Page Banner-->

        <!--Start Scout Area-->
        <div class="privacy-policy-area pt-100 pb-70">
            <div class="container">
                <div class="row">
                    <div class="col-lg-8">
                        <div class="privacy-content pr-20">
                            <h2>Scouts and Guide</h2>
                            <p>Please read this Scouts and Guide Cell details carefully </p>

                            <p>Scout /guide ( Ranger) team is a unit of Bharat scout guide. Ranger team is running in college since 2011. Our students do service for people they have been doing many social work like khatu fair, bhairu fair hospital camp, summer water drinking service, parinda abhiyan etc.</p>

                            <p>In 2015 Our 5 students awarded by Rashtrapati award.every year students awarded with governor award.during COVID -19 our students n college awarded with best COVID -19 worriors award.and in 2014-2020 our students awarded with uprasthrapati award. </p>

                            <p>11 girls participants in Neepun award, Rajya puraskar training camp and 2nd L.A Reengus competition ralley at Bawari Balaji dham, Village Bawari. Winning shield in different competition. 1st position in folk dance  and singing,fancy dress,vichitra veshbhusa. </p>

                            <p>They are referred to as: “Duty to God”, “Duty to others” and “Duty to self”.</p>

                        </div>
                        <hr/>
                        <b>Bharat Scouts & Guides laws:</b>
                        <div>
                            <ul>
                                <li>A Guide is trustworthy.</li>
                                <li>A Guide is loyal.</li>
                                <li>A Guide is a friend to all and a sister to every other Guide.</li>
                                <li>A Guide is courteous.</li>
                                <li>A Guide is a friend to animals and loves nature.</li>
                                <li>A Guide is disciplined and helps protect public property.</li>
                                <li>A Guide is courageous.</li>
                                <li>A Guide is thrifty.</li>
                                <li>A Guide is pure in thought, word, and deed</li>
                            </ul>
                        </div>
                    </div>

                    <div class="col-lg-4">
                        <div class="privacy-left-content pl-20">
                            <div class="team-img-box"> <img width="460" height="500"
                                    src="/vf/images/cells/C3_inner.png"
                                    class="attachment-post-thumbnail size-post-thumbnail wp-post-image" alt=""
                                    decoding="async" fetchpriority="high"></div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <!--End Scout Area-->


        <!-- Start Bottom Connect Area -->
         <div class="alumni-interview-area pb-100">
            <div class="container">
                <div class="interview-content ptb-100">
                    <div class="interview">
                        <a href="https://rdc.eshala.co.in/events" class="default-btn btn">Events<i
                                class="flaticon-next"></i></a>
                        <a href="https://rdc.eshala.co.in/page/enquiry" class="default-btn btn">Apply Now<i
                                class="flaticon-next"></i></a>
                    </div>
                </div>
            </div>
        </div>
        <!--End Bottom Connect Area -->
</template>

<script>
export default {
    name : "WDCView"
};
</script>
